import React from 'react'
import { ApproachSelect } from '../../../components'
import { SystemProvider } from '../../../features/system/provider'
import { updateForm as updateResourceForm } from '../../../features/resource-form/slice'
import { useDispatch, useSelector } from 'react-redux'
import debounce from 'lodash.debounce'

const SidebarApproach = () => {
  const dispatch = useDispatch()
  const form = useSelector(state => state.resourceForm.data)
  const { approach } = form
  const updateForm = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateResourceForm({key, value}))
    }
  }, 250)

  return (
    <SystemProvider>
      <ApproachSelect
        defaultValues={approach}
        updateForm={updateForm}
      />
    </SystemProvider>
  )
}

export { SidebarApproach }
